import {Component, OnDestroy, OnInit} from '@angular/core';
import {LoggerService} from "../common/logger.service";
import {UsanaObject} from "../usana-object";
import {AlertService} from "./alert.service";
import {IAlert} from "./alert-model";
import {Subscription} from "rxjs";

@Component({
    selector: 'alert-list',
    templateUrl: './alert-list.component.html',
    styleUrls: ['./alert.scss'],
    standalone: false
})
export class AlertListComponent extends UsanaObject implements OnInit, OnDestroy {

    alerts: IAlert[];
    alertSubscription: Subscription;

    constructor(loggerService: LoggerService, private alertService: AlertService) {
        super(loggerService);
    }

    ngOnInit() {
        this.alertSubscription = this.alertService.alertsSubject.subscribe((alerts: IAlert[]) => this.alerts = alerts);
    }

    ngOnDestroy() {
        this.alertSubscription.unsubscribe();
    }

    getListClass(): string {
        if (window.scrollY > 200) {
            return "phx-alerts-top";
        } else {
            return "phx-alerts";
        }
    }
}
